//#region ../event-service/dist/service.types-C7k29EN3.js
var e = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, t = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, n = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.30/node_modules/@vue/shared/dist/shared.esm-bundler.js
/* @__NO_SIDE_EFFECTS__ */
function r(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var i = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var a = () => {}, o = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), s = Object.assign, c = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, l = Object.prototype.hasOwnProperty, u = (e, t) => l.call(e, t), d = Array.isArray, f = (e) => y(e) === "[object Map]", p = (e) => y(e) === "[object Set]", m = (e) => typeof e == "function", h = (e) => typeof e == "string", g = (e) => typeof e == "symbol", _ = (e) => typeof e == "object" && !!e, v = (e) => (_(e) || m(e)) && m(e.then) && m(e.catch), ee = Object.prototype.toString, y = (e) => ee.call(e), b = (e) => y(e).slice(8, -1), te = (e) => y(e) === "[object Object]", x = (e) => h(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, S = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), C = (e, t) => !Object.is(e, t), w = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, ne, re = () => ne ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function ie(e) {
	if (d(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = h(r) ? ce(r) : ie(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (h(e) || _(e)) return e;
}
var ae = /;(?![^(]*\))/g, oe = /:([^]+)/, se = /\/\*[^]*?\*\//g;
function ce(e) {
	let t = {};
	return e.replace(se, "").split(ae).forEach((e) => {
		if (e) {
			let n = e.split(oe);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function le(e) {
	let t = "";
	if (h(e)) t = e;
	else if (d(e)) for (let n = 0; n < e.length; n++) {
		let r = le(e[n]);
		r && (t += r + " ");
	}
	else if (_(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.30/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function T(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var ue;
function de() {
	return ue;
}
var E, fe = /* @__PURE__ */ new WeakSet(), pe = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, ue && ue.active && ue.effects.push(this);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, fe.has(this) && (fe.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || _e(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, De(this), be(this);
		let e = E, t = D;
		E = this, D = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && E !== this && T("Active effect was not restored correctly - this is likely a Vue internal bug."), xe(this), E = e, D = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) we(e);
			this.deps = this.depsTail = void 0, De(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? fe.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		Se(this) && this.run();
	}
	get dirty() {
		return Se(this);
	}
}, me = 0, he, ge;
function _e(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = ge, ge = e;
		return;
	}
	e.next = he, he = e;
}
function ve() {
	me++;
}
function ye() {
	if (--me > 0) return;
	if (ge) {
		let e = ge;
		for (ge = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; he;) {
		let t = he;
		for (he = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function be(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function xe(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), we(r), Te(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function Se(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Ce(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Ce(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Oe) || (e.globalVersion = Oe, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Se(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = E, r = D;
	E = e, D = !0;
	try {
		be(e);
		let n = e.fn(e._value);
		(t.version === 0 || C(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		E = n, D = r, xe(e), e.flags &= -3;
	}
}
function we(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) we(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function Te(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var D = !0, Ee = [];
function O() {
	Ee.push(D), D = !1;
}
function k() {
	let e = Ee.pop();
	D = e === void 0 ? !0 : e;
}
function De(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = E;
		E = void 0;
		try {
			t();
		} finally {
			E = e;
		}
	}
}
var Oe = 0, ke = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, Ae = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!E || !D || E === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== E) t = this.activeLink = new ke(E, this), E.deps ? (t.prevDep = E.depsTail, E.depsTail.nextDep = t, E.depsTail = t) : E.deps = E.depsTail = t, je(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = E.depsTail, t.nextDep = void 0, E.depsTail.nextDep = t, E.depsTail = t, E.deps === t && (E.deps = e);
		}
		return process.env.NODE_ENV !== "production" && E.onTrack && E.onTrack(s({ effect: E }, e)), t;
	}
	trigger(e) {
		this.version++, Oe++, this.notify(e);
	}
	notify(e) {
		ve();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(s({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			ye();
		}
	}
};
function je(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) je(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var Me = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Ne = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), Pe = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function j(e, t, n) {
	if (D && E) {
		let r = Me.get(e);
		r || Me.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new Ae()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function M(e, t, n, r, i, a) {
	let o = Me.get(e);
	if (!o) {
		Oe++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (ve(), t === "clear") o.forEach(s);
	else {
		let i = d(e), a = i && x(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === Pe || !g(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(Pe)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(A)), f(e) && s(o.get(Ne)));
				break;
			case "delete":
				i || (s(o.get(A)), f(e) && s(o.get(Ne)));
				break;
			case "set":
				f(e) && s(o.get(A));
				break;
		}
	}
	ye();
}
function N(e) {
	let t = /* @__PURE__ */ z(e);
	return t === e ? t : (j(t, "iterate", Pe), /* @__PURE__ */ R(e) ? t : t.map(B));
}
function Fe(e) {
	return j(e = /* @__PURE__ */ z(e), "iterate", Pe), e;
}
function P(e, t) {
	return /* @__PURE__ */ L(e) ? yt(/* @__PURE__ */ I(e) ? B(t) : t) : B(t);
}
var Ie = {
	__proto__: null,
	[Symbol.iterator]() {
		return Le(this, Symbol.iterator, (e) => P(this, e));
	},
	concat(...e) {
		return N(this).concat(...e.map((e) => d(e) ? N(e) : e));
	},
	entries() {
		return Le(this, "entries", (e) => (e[1] = P(this, e[1]), e));
	},
	every(e, t) {
		return F(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return F(this, "filter", e, t, (e) => e.map((e) => P(this, e)), arguments);
	},
	find(e, t) {
		return F(this, "find", e, t, (e) => P(this, e), arguments);
	},
	findIndex(e, t) {
		return F(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return F(this, "findLast", e, t, (e) => P(this, e), arguments);
	},
	findLastIndex(e, t) {
		return F(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return F(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return Be(this, "includes", e);
	},
	indexOf(...e) {
		return Be(this, "indexOf", e);
	},
	join(e) {
		return N(this).join(e);
	},
	lastIndexOf(...e) {
		return Be(this, "lastIndexOf", e);
	},
	map(e, t) {
		return F(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return Ve(this, "pop");
	},
	push(...e) {
		return Ve(this, "push", e);
	},
	reduce(e, ...t) {
		return ze(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return ze(this, "reduceRight", e, t);
	},
	shift() {
		return Ve(this, "shift");
	},
	some(e, t) {
		return F(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return Ve(this, "splice", e);
	},
	toReversed() {
		return N(this).toReversed();
	},
	toSorted(e) {
		return N(this).toSorted(e);
	},
	toSpliced(...e) {
		return N(this).toSpliced(...e);
	},
	unshift(...e) {
		return Ve(this, "unshift", e);
	},
	values() {
		return Le(this, "values", (e) => P(this, e));
	}
};
function Le(e, t, n) {
	let r = Fe(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ R(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var Re = Array.prototype;
function F(e, t, n, r, i, a) {
	let o = Fe(e), s = o !== e && !/* @__PURE__ */ R(e), c = o[t];
	if (c !== Re[t]) {
		let t = c.apply(e, a);
		return s ? B(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, P(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function ze(e, t, n, r) {
	let i = Fe(e), a = i !== e && !/* @__PURE__ */ R(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = P(e, t)), n.call(this, t, P(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? P(e, c) : c;
}
function Be(e, t, n) {
	let r = /* @__PURE__ */ z(e);
	j(r, "iterate", Pe);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ _t(n[0]) ? (n[0] = /* @__PURE__ */ z(n[0]), r[t](...n)) : i;
}
function Ve(e, t, n = []) {
	O(), ve();
	let r = (/* @__PURE__ */ z(e))[t].apply(e, n);
	return ye(), k(), r;
}
var He = /* @__PURE__ */ r("__proto__,__v_isRef,__isVue"), Ue = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(g));
function We(e) {
	g(e) || (e = String(e));
	let t = /* @__PURE__ */ z(this);
	return j(t, "has", e), t.hasOwnProperty(e);
}
var Ge = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? ut : lt : i ? ct : st).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = d(e);
		if (!r) {
			let e;
			if (a && (e = Ie[t])) return e;
			if (t === "hasOwnProperty") return We;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ V(e) ? e : n);
		if ((g(t) ? Ue.has(t) : He(t)) || (r || j(e, "get", t), i)) return o;
		if (/* @__PURE__ */ V(o)) {
			let e = a && x(t) ? o : o.value;
			return r && _(e) ? /* @__PURE__ */ mt(e) : e;
		}
		return _(o) ? r ? /* @__PURE__ */ mt(o) : /* @__PURE__ */ pt(o) : o;
	}
}, Ke = class extends Ge {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = d(e) && x(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ L(i);
			if (!/* @__PURE__ */ R(n) && !/* @__PURE__ */ L(n) && (i = /* @__PURE__ */ z(i), n = /* @__PURE__ */ z(n)), !a && /* @__PURE__ */ V(i) && !/* @__PURE__ */ V(n)) return r ? (process.env.NODE_ENV !== "production" && T(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : u(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ V(e) ? e : r);
		return e === /* @__PURE__ */ z(r) && (o ? C(n, i) && M(e, "set", t, n, i) : M(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = u(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && M(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!g(t) || !Ue.has(t)) && j(e, "has", t), n;
	}
	ownKeys(e) {
		return j(e, "iterate", d(e) ? "length" : A), Reflect.ownKeys(e);
	}
}, qe = class extends Ge {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && T(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && T(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, Je = /* @__PURE__ */ new Ke(), Ye = /* @__PURE__ */ new qe(), Xe = /* @__PURE__ */ new qe(!0), Ze = (e) => e, Qe = (e) => Reflect.getPrototypeOf(e);
function $e(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ z(i), o = f(a), c = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, u = i[e](...r), d = n ? Ze : t ? yt : B;
		return !t && j(a, "iterate", l ? Ne : A), s(Object.create(u), { next() {
			let { value: e, done: t } = u.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: c ? [d(e[0]), d(e[1])] : d(e),
				done: t
			};
		} });
	};
}
function et(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			T(`${S(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ z(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function tt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ z(r), a = /* @__PURE__ */ z(n);
			e || (C(n, a) && j(i, "get", n), j(i, "get", a));
			let { has: o } = Qe(i), s = t ? Ze : e ? yt : B;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && j(/* @__PURE__ */ z(t), "iterate", A), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ z(n), i = /* @__PURE__ */ z(t);
			return e || (C(t, i) && j(r, "has", t), j(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ z(a), s = t ? Ze : e ? yt : B;
			return !e && j(o, "iterate", A), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return s(n, e ? {
		add: et("add"),
		set: et("set"),
		delete: et("delete"),
		clear: et("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ z(this), r = Qe(n), i = /* @__PURE__ */ z(e), a = !t && !/* @__PURE__ */ R(e) && !/* @__PURE__ */ L(e) ? i : e;
			return r.has.call(n, a) || C(e, a) && r.has.call(n, e) || C(i, a) && r.has.call(n, i) || (n.add(a), M(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ R(n) && !/* @__PURE__ */ L(n) && (n = /* @__PURE__ */ z(n));
			let r = /* @__PURE__ */ z(this), { has: i, get: a } = Qe(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && ot(r, i, e) : (e = /* @__PURE__ */ z(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? C(n, s) && M(r, "set", e, n, s) : M(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ z(this), { has: n, get: r } = Qe(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && ot(t, n, e) : (e = /* @__PURE__ */ z(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && M(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ z(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : f(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && M(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = $e(r, e, t);
	}), n;
}
function nt(e, t) {
	let n = tt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(u(n, r) && r in t ? n : t, r, i);
}
var rt = { get: /* @__PURE__ */ nt(!1, !1) }, it = { get: /* @__PURE__ */ nt(!0, !1) }, at = { get: /* @__PURE__ */ nt(!0, !0) };
function ot(e, t, n) {
	let r = /* @__PURE__ */ z(n);
	if (r !== n && t.call(e, r)) {
		let t = b(e);
		T(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var st = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakMap(), ut = /* @__PURE__ */ new WeakMap();
function dt(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
function ft(e) {
	return e.__v_skip || !Object.isExtensible(e) ? 0 : dt(b(e));
}
/* @__NO_SIDE_EFFECTS__ */
function pt(e) {
	return /* @__PURE__ */ L(e) ? e : gt(e, !1, Je, rt, st);
}
/* @__NO_SIDE_EFFECTS__ */
function mt(e) {
	return gt(e, !0, Ye, it, lt);
}
/* @__NO_SIDE_EFFECTS__ */
function ht(e) {
	return gt(e, !0, Xe, at, ut);
}
function gt(e, t, n, r, i) {
	if (!_(e)) return process.env.NODE_ENV !== "production" && T(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive)) return e;
	let a = ft(e);
	if (a === 0) return e;
	let o = i.get(e);
	if (o) return o;
	let s = new Proxy(e, a === 2 ? r : n);
	return i.set(e, s), s;
}
/* @__NO_SIDE_EFFECTS__ */
function I(e) {
	return /* @__PURE__ */ L(e) ? /* @__PURE__ */ I(e.__v_raw) : !!(e && e.__v_isReactive);
}
/* @__NO_SIDE_EFFECTS__ */
function L(e) {
	return !!(e && e.__v_isReadonly);
}
/* @__NO_SIDE_EFFECTS__ */
function R(e) {
	return !!(e && e.__v_isShallow);
}
/* @__NO_SIDE_EFFECTS__ */
function _t(e) {
	return e ? !!e.__v_raw : !1;
}
/* @__NO_SIDE_EFFECTS__ */
function z(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ z(t) : e;
}
function vt(e) {
	return !u(e, "__v_skip") && Object.isExtensible(e) && w(e, "__v_skip", !0), e;
}
var B = (e) => _(e) ? /* @__PURE__ */ pt(e) : e, yt = (e) => _(e) ? /* @__PURE__ */ mt(e) : e;
/* @__NO_SIDE_EFFECTS__ */
function V(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function bt(e) {
	return /* @__PURE__ */ V(e) ? e.value : e;
}
var xt = {
	get: (e, t, n) => t === "__v_raw" ? e : bt(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ V(i) && !/* @__PURE__ */ V(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function St(e) {
	return /* @__PURE__ */ I(e) ? e : new Proxy(e, xt);
}
var Ct = {}, wt = /* @__PURE__ */ new WeakMap(), H = void 0;
function Tt(e, t = !1, n = H) {
	if (n) {
		let t = wt.get(n);
		t || wt.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && T("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Et(e, t, n = i) {
	let { immediate: r, deep: o, once: s, scheduler: l, augmentJob: u, call: f } = n, p = (e) => {
		(n.onWarn || T)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, h = (e) => o ? e : /* @__PURE__ */ R(e) || o === !1 || o === 0 ? U(e, 1) : U(e), g, _, v, ee, y = !1, b = !1;
	if (/* @__PURE__ */ V(e) ? (_ = () => e.value, y = /* @__PURE__ */ R(e)) : /* @__PURE__ */ I(e) ? (_ = () => h(e), y = !0) : d(e) ? (b = !0, y = e.some((e) => /* @__PURE__ */ I(e) || /* @__PURE__ */ R(e)), _ = () => e.map((e) => {
		if (/* @__PURE__ */ V(e)) return e.value;
		if (/* @__PURE__ */ I(e)) return h(e);
		if (m(e)) return f ? f(e, 2) : e();
		process.env.NODE_ENV !== "production" && p(e);
	})) : m(e) ? _ = t ? f ? () => f(e, 2) : e : () => {
		if (v) {
			O();
			try {
				v();
			} finally {
				k();
			}
		}
		let t = H;
		H = g;
		try {
			return f ? f(e, 3, [ee]) : e(ee);
		} finally {
			H = t;
		}
	} : (_ = a, process.env.NODE_ENV !== "production" && p(e)), t && o) {
		let e = _, t = o === !0 ? Infinity : o;
		_ = () => U(e(), t);
	}
	let te = de(), x = () => {
		g.stop(), te && te.active && c(te.effects, g);
	};
	if (s && t) {
		let e = t;
		t = (...t) => {
			e(...t), x();
		};
	}
	let S = b ? Array(e.length).fill(Ct) : Ct, w = (e) => {
		if (!(!(g.flags & 1) || !g.dirty && !e)) if (t) {
			let e = g.run();
			if (o || y || (b ? e.some((e, t) => C(e, S[t])) : C(e, S))) {
				v && v();
				let n = H;
				H = g;
				try {
					let n = [
						e,
						S === Ct ? void 0 : b && S[0] === Ct ? [] : S,
						ee
					];
					S = e, f ? f(t, 3, n) : t(...n);
				} finally {
					H = n;
				}
			}
		} else g.run();
	};
	return u && u(w), g = new pe(_), g.scheduler = l ? () => l(w, !1) : w, ee = (e) => Tt(e, !1, g), v = g.onStop = () => {
		let e = wt.get(g);
		if (e) {
			if (f) f(e, 4);
			else for (let t of e) t();
			wt.delete(g);
		}
	}, process.env.NODE_ENV !== "production" && (g.onTrack = n.onTrack, g.onTrigger = n.onTrigger), t ? r ? w(!0) : S = g.run() : l ? l(w.bind(null, !0), !0) : g.run(), x.pause = g.pause.bind(g), x.resume = g.resume.bind(g), x.stop = x, x;
}
function U(e, t = Infinity, n) {
	if (t <= 0 || !_(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ V(e)) U(e.value, t, n);
	else if (d(e)) for (let r = 0; r < e.length; r++) U(e[r], t, n);
	else if (p(e) || f(e)) e.forEach((e) => {
		U(e, t, n);
	});
	else if (te(e)) {
		for (let r in e) U(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && U(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.30/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var W = [];
function Dt(e) {
	W.push(e);
}
function Ot() {
	W.pop();
}
var kt = !1;
function G(e, ...t) {
	if (kt) return;
	kt = !0, O();
	let n = W.length ? W[W.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = At();
	if (r) It(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${gr(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...jt(i)), console.warn(...n);
	}
	k(), kt = !1;
}
function At() {
	let e = W[W.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function jt(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...Mt(e));
	}), t;
}
function Mt({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${gr(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Nt(e.props),
		a
	] : [i + a];
}
function Nt(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Pt(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Pt(e, t, n) {
	return h(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ V(t) ? (t = Pt(e, /* @__PURE__ */ z(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : m(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ z(t), n ? t : [`${e}=`, t]);
}
var Ft = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function It(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Rt(e, t, n);
	}
}
function Lt(e, t, n, r) {
	if (m(e)) {
		let i = It(e, t, n, r);
		return i && v(i) && i.catch((e) => {
			Rt(e, t, n);
		}), i;
	}
	if (d(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(Lt(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && G(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function Rt(e, t, n, r = !0) {
	let a = t ? t.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: s } = t && t.appContext.config || i;
	if (t) {
		let r = t.parent, i = t.proxy, a = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : Ft[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, a) === !1) return;
			}
			r = r.parent;
		}
		if (o) {
			O(), It(o, null, 10, [
				e,
				i,
				a
			]), k();
			return;
		}
	}
	zt(e, n, a, r, s);
}
function zt(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = Ft[t];
		if (n && Dt(n), G(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Ot(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var K = [], q = -1, J = [], Y = null, X = 0, Bt = /* @__PURE__ */ Promise.resolve(), Vt = null, Ht = 100;
function Ut(e) {
	let t = Vt || Bt;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function Wt(e) {
	let t = q + 1, n = K.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = K[r], a = Yt(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Gt(e) {
	if (!(e.flags & 1)) {
		let t = Yt(e), n = K[K.length - 1];
		!n || !(e.flags & 2) && t >= Yt(n) ? K.push(e) : K.splice(Wt(t), 0, e), e.flags |= 1, Kt();
	}
}
function Kt() {
	Vt ||= Bt.then(Xt);
}
function qt(e) {
	d(e) ? J.push(...e) : Y && e.id === -1 ? Y.splice(X + 1, 0, e) : e.flags & 1 || (J.push(e), e.flags |= 1), Kt();
}
function Jt(e) {
	if (J.length) {
		let t = [...new Set(J)].sort((e, t) => Yt(e) - Yt(t));
		if (J.length = 0, Y) {
			Y.push(...t);
			return;
		}
		for (Y = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), X = 0; X < Y.length; X++) {
			let t = Y[X];
			process.env.NODE_ENV !== "production" && Zt(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		Y = null, X = 0;
	}
}
var Yt = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function Xt(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? a : (t) => Zt(e, t);
	try {
		for (q = 0; q < K.length; q++) {
			let e = K[q];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), It(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; q < K.length; q++) {
			let e = K[q];
			e && (e.flags &= -2);
		}
		q = -1, K.length = 0, Jt(e), Vt = null, (K.length || J.length) && Xt(e);
	}
}
function Zt(e, t) {
	let n = e.get(t) || 0;
	if (n > Ht) {
		let e = t.i, n = e && hr(e.type);
		return Rt(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Qt = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (re().__VUE_HMR_RUNTIME__ = {
	createRecord: on(en),
	rerender: on(nn),
	reload: on(rn)
});
var $t = /* @__PURE__ */ new Map();
function en(e, t) {
	return $t.has(e) ? !1 : ($t.set(e, {
		initialDef: tn(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function tn(e) {
	return _r(e) ? e.__vccOpts : e;
}
function nn(e, t) {
	let n = $t.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, tn(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function rn(e, t) {
	let n = $t.get(e);
	if (!n) return;
	t = tn(t), an(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = tn(i.type), o = Qt.get(a);
		o || (a !== n.initialDef && an(a, t), Qt.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Gt(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	qt(() => {
		Qt.clear();
	});
}
function an(e, t) {
	s(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function on(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var sn, cn = [];
function ln(e, t) {
	sn = e, sn ? (sn.enabled = !0, cn.forEach(({ event: e, args: t }) => sn.emit(e, ...t)), cn = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		ln(e, t);
	}), setTimeout(() => {
		sn || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, cn = []);
	}, 3e3)) : cn = [];
}
var Z = null, un = null;
function dn(e, t, n = !1) {
	let r = sr();
	if (r || In) {
		let i = In ? In._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && m(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && G(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && G("inject() can only be used inside setup() or functional components.");
}
var fn = /* @__PURE__ */ Symbol.for("v-scx"), pn = () => {
	{
		let e = dn(fn);
		return e || process.env.NODE_ENV !== "production" && G("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function mn(e, t, n = i) {
	let { immediate: r, deep: o, flush: c, once: l } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && G("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && G("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), l !== void 0 && G("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let u = s({}, n);
	process.env.NODE_ENV !== "production" && (u.onWarn = G);
	let d = t && r || !t && c !== "post", f;
	if (dr) {
		if (c === "sync") {
			let e = pn();
			f = e.__watcherHandles ||= [];
		} else if (!d) {
			let e = () => {};
			return e.stop = a, e.resume = a, e.pause = a, e;
		}
	}
	let p = or;
	u.call = (e, t, n) => Lt(e, p, t, n);
	let m = !1;
	c === "post" ? u.scheduler = (e) => {
		zn(e, p && p.suspense);
	} : c !== "sync" && (m = !0, u.scheduler = (e, t) => {
		t ? e() : Gt(e);
	}), u.augmentJob = (e) => {
		t && (e.flags |= 4), m && (e.flags |= 2, p && (e.id = p.uid, e.i = p));
	};
	let h = Et(e, t, u);
	return dr && (f ? f.push(h) : d && h()), h;
}
function hn(e, t, n) {
	let r = this.proxy, i = h(e) ? e.includes(".") ? gn(r, e) : () => r[e] : e.bind(r, r), a;
	m(t) ? a = t : (a = t.handler, n = t);
	let o = lr(this), s = mn(i, a.bind(r), n);
	return o(), s;
}
function gn(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var _n = (e) => e.__isTeleport;
function vn(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, vn(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
re().requestIdleCallback, re().cancelIdleCallback;
var yn = /* @__PURE__ */ Symbol.for("v-ndc"), bn = (e) => e ? ur(e) ? fr(e) : bn(e.parent) : null, xn = /* @__PURE__ */ s(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ ht(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ ht(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ ht(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ ht(e.refs),
	$parent: (e) => bn(e.parent),
	$root: (e) => bn(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? Dn(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		Gt(e.update);
	},
	$nextTick: (e) => e.n ||= Ut.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? hn.bind(e) : a
}), Sn = (e) => e === "_" || e === "$", Cn = (e, t) => e !== i && !e.__isScriptSetup && u(e, t), wn = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: a, props: o, accessCache: s, type: c, appContext: l } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = s[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return a[t];
				case 4: return n[t];
				case 3: return o[t];
			}
			else if (Cn(r, t)) return s[t] = 1, r[t];
			else if (__VUE_OPTIONS_API__ && a !== i && u(a, t)) return s[t] = 2, a[t];
			else if (u(o, t)) return s[t] = 3, o[t];
			else if (n !== i && u(n, t)) return s[t] = 4, n[t];
			else (!__VUE_OPTIONS_API__ || En) && (s[t] = 0);
		}
		let d = xn[t], f, p;
		if (d) return t === "$attrs" ? (j(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && j(e, "get", t), d(e);
		if ((f = c.__cssModules) && (f = f[t])) return f;
		if (n !== i && u(n, t)) return s[t] = 4, n[t];
		if (p = l.config.globalProperties, u(p, t)) return p[t];
		process.env.NODE_ENV !== "production" && Z && (!h(t) || t.indexOf("__v") !== 0) && (a !== i && Sn(t[0]) && u(a, t) ? G(`Property ${JSON.stringify(t)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`) : e === Z && G(`Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`));
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: a, ctx: o } = e;
		return Cn(a, t) ? (a[t] = n, !0) : process.env.NODE_ENV !== "production" && a.__isScriptSetup && u(a, t) ? (G(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : __VUE_OPTIONS_API__ && r !== i && u(r, t) ? (r[t] = n, !0) : u(e.props, t) ? (process.env.NODE_ENV !== "production" && G(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && G(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(o, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : o[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: a, props: o, type: s } }, c) {
		let l;
		return !!(n[c] || __VUE_OPTIONS_API__ && e !== i && c[0] !== "$" && u(e, c) || Cn(t, c) || u(o, c) || u(r, c) || u(xn, c) || u(a.config.globalProperties, c) || (l = s.__cssModules) && l[c]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? u(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (wn.ownKeys = (e) => (G("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function Tn(e) {
	return d(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var En = !0;
function Dn(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => On(c, e, o, !0)), On(c, t, o)), _(t) && a.set(t, c), c;
}
function On(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && On(e, a, n, !0), i && i.forEach((t) => On(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && G("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = kn[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var kn = {
	data: An,
	props: Pn,
	emits: Pn,
	methods: Nn,
	computed: Nn,
	beforeCreate: Q,
	created: Q,
	beforeMount: Q,
	mounted: Q,
	beforeUpdate: Q,
	updated: Q,
	beforeDestroy: Q,
	beforeUnmount: Q,
	destroyed: Q,
	unmounted: Q,
	activated: Q,
	deactivated: Q,
	errorCaptured: Q,
	serverPrefetch: Q,
	components: Nn,
	directives: Nn,
	watch: Fn,
	provide: An,
	inject: jn
};
function An(e, t) {
	return t ? e ? function() {
		return s(m(e) ? e.call(this, this) : e, m(t) ? t.call(this, this) : t);
	} : t : e;
}
function jn(e, t) {
	return Nn(Mn(e), Mn(t));
}
function Mn(e) {
	if (d(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function Q(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function Nn(e, t) {
	return e ? s(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Pn(e, t) {
	return e ? d(e) && d(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : s(/* @__PURE__ */ Object.create(null), Tn(e), Tn(t ?? {})) : t;
}
function Fn(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = s(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = Q(e[r], t[r]);
	return n;
}
var In = null, Ln = {}, Rn = (e) => Object.getPrototypeOf(e) === Ln, zn = Vn, Bn = (e) => e.__isSuspense;
function Vn(e, t) {
	t && t.pendingBranch ? d(e) ? t.effects.push(...e) : t.effects.push(e) : qt(e);
}
var Hn = /* @__PURE__ */ Symbol.for("v-fgt"), Un = /* @__PURE__ */ Symbol.for("v-txt"), Wn = /* @__PURE__ */ Symbol.for("v-cmt"), $ = null, Gn = 1;
function Kn(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var qn, Jn = (...e) => $n(...qn ? qn(e, Z) : e), Yn = ({ key: e }) => e ?? null, Xn = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : h(e) || /* @__PURE__ */ V(e) || m(e) ? {
	i: Z,
	r: e,
	k: t,
	f: !!n
} : e);
function Zn(e, t = null, n = null, r = 0, i = null, a = e === Hn ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && Yn(t),
		ref: t && Xn(t),
		scopeId: un,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Z
	};
	return s ? (ir(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= h(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && G("VNode created with invalid key (NaN). VNode type:", c.type), Gn > 0 && !o && $ && (c.patchFlag > 0 || a & 6) && c.patchFlag !== 32 && $.push(c), c;
}
var Qn = process.env.NODE_ENV === "production" ? $n : Jn;
function $n(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === yn) && (process.env.NODE_ENV !== "production" && !e && G(`Invalid vnode type when creating vnode: ${e}.`), e = Wn), Kn(e)) {
		let r = tr(e, t, !0);
		return n && ir(r, n), Gn > 0 && !a && $ && (r.shapeFlag & 6 ? $[$.indexOf(e)] = r : $.push(r)), r.patchFlag = -2, r;
	}
	if (_r(e) && (e = e.__vccOpts), t) {
		t = er(t);
		let { class: e, style: n } = t;
		e && !h(e) && (t.class = le(e)), _(n) && (/* @__PURE__ */ _t(n) && !d(n) && (n = s({}, n)), t.style = ie(n));
	}
	let o = h(e) ? 1 : Bn(e) ? 128 : _n(e) ? 64 : _(e) ? 4 : m(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ _t(e) && (e = /* @__PURE__ */ z(e), G("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Zn(e, t, n, r, i, o, a, !0);
}
function er(e) {
	return e ? /* @__PURE__ */ _t(e) || Rn(e) ? s({}, e) : e : null;
}
function tr(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? ar(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && Yn(l),
		ref: t && t.ref ? n && a ? d(a) ? a.concat(Xn(t)) : [a, Xn(t)] : Xn(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && d(s) ? s.map(nr) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== Hn ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && tr(e.ssContent),
		ssFallback: e.ssFallback && tr(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && vn(u, c.clone(u)), u;
}
function nr(e) {
	let t = tr(e);
	return d(e.children) && (t.children = e.children.map(nr)), t;
}
function rr(e = " ", t = 0) {
	return Qn(Un, null, e, t);
}
function ir(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (d(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), ir(e, n()), n._c && (n._d = !0));
		return;
	} else {
		n = 32;
		let r = t._;
		!r && !Rn(t) ? t._ctx = Z : r === 3 && Z && (Z.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
	}
	else m(t) ? (t = {
		default: t,
		_ctx: Z
	}, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [rr(t)]) : n = 8);
	e.children = t, e.shapeFlag |= n;
}
function ar(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = le([t.class, r.class]));
		else if (e === "style") t.style = ie([t.style, r.style]);
		else if (o(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(d(n) && n.includes(i)) && (t[e] = n ? [].concat(n, i) : i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var or = null, sr = () => or || Z, cr;
{
	let e = re(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	cr = t("__VUE_INSTANCE_SETTERS__", (e) => or = e), t("__VUE_SSR_SETTERS__", (e) => dr = e);
}
var lr = (e) => {
	let t = or;
	return cr(e), e.scope.on(), () => {
		e.scope.off(), cr(t);
	};
};
function ur(e) {
	return e.vnode.shapeFlag & 4;
}
var dr = !1;
process.env.NODE_ENV;
function fr(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(St(vt(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in xn) return xn[n](e);
		},
		has(e, t) {
			return t in e || t in xn;
		}
	}) : e.proxy;
}
var pr = /(?:^|[-_])\w/g, mr = (e) => e.replace(pr, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function hr(e, t = !0) {
	return m(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function gr(e, t, n = !1) {
	let r = hr(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? mr(r) : n ? "App" : "Anonymous";
}
function _r(e) {
	return m(e) && "__vccOpts" in e;
}
function vr() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, a = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!_(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ V(t)) {
				O();
				let n = t.value;
				return k(), [
					"div",
					{},
					[
						"span",
						e,
						p(t)
					],
					"<",
					l(n),
					">"
				];
			} else if (/* @__PURE__ */ I(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ R(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				l(t),
				`>${/* @__PURE__ */ L(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ L(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ R(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				l(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...o(e.$)
			];
		}
	};
	function o(e) {
		let t = [];
		e.type.props && e.props && t.push(c("props", /* @__PURE__ */ z(e.props))), e.setupState !== i && t.push(c("setup", e.setupState)), e.data !== i && t.push(c("data", /* @__PURE__ */ z(e.data)));
		let n = u(e, "computed");
		n && t.push(c("computed", n));
		let a = u(e, "inject");
		return a && t.push(c("injected", a)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function c(e, t) {
		return t = s({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					l(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function l(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : _(e) ? ["object", { object: i ? /* @__PURE__ */ z(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function u(e, t) {
		let n = e.type;
		if (m(n)) return;
		let r = {};
		for (let i in e.ctx) f(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function f(e, t, n) {
		let r = e[n];
		if (d(r) && r.includes(t) || _(r) && t in r || e.extends && f(e.extends, t, n) || e.mixins && e.mixins.some((e) => f(e, t, n))) return !0;
	}
	function p(e) {
		return /* @__PURE__ */ R(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(a) : window.devtoolsFormatters = [a];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.30_typescript@5.5.4/node_modules/vue/dist/vue.runtime.esm-bundler.js
function yr() {
	vr();
}
process.env.NODE_ENV !== "production" && yr();
//#endregion
export { n, t as r, e as t };
